import React from "react";
import { useEffect } from "react";
import { useLocation, Outlet, useNavigate } from "react-router-dom";
import { Provider } from "react-redux";
import { store } from "./store/store.js";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import styled from "styled-components";
import Footer from "./common/footer.jsx";
import { useSelector } from "react-redux";
import Header from "./common/header.jsx";
import useUserAuthActions from "./hooks/useUserStorage.jsx";

const CustomToast = styled(ToastContainer)`
  z-index: 10000;
  width: "400px";
  font-weight: 600;
  font-size: 16px;
  @media screen and (max-width: 767px) {
    width: 100%;
  }
`;

const AppLoginContent = () => {
  const { checkAndLogin } = useUserAuthActions();

  useEffect(() => {
    if (!window.Kakao || !window.Kakao.isInitialized()) {
      // Kakao.init("b9886faecde9faa67a51166600a9d107"); // 개발 환경에 맞는 API 키 사용
      Kakao.init("4970bf08e349ccf4b295296035944317"); // 운영 환경에 맞는 API 키 사용
    }
  }, []);

  const { pathname } = useLocation();

  const navigate = useNavigate();
  const user = useSelector((state) => state?.user?.data[0]);

  useEffect(() => {
    document.title = "모노티";

    window.scrollTo(0, 0);
    changeBodyClassName();
  }, [pathname]);

  useEffect(() => {
    const checkLoginStatus = async () => {
      if (!user) {
        const isLoggedIn = await checkAndLogin();
        if (!isLoggedIn) {
          navigate("/login");
        }
      }
    };

    checkLoginStatus();
  }, [user, checkAndLogin, navigate]);

  const isShowComponent = (name) => {
    const domains = [
      "scheduler",
      "detailEvent",
      "notify",
      "project",
      "filebox",
      "mypage/search",
      "kiosk",
      "bbdabang",
      "store",
      "selectTemplate",
    ];
    if (domains.some((excludeName) => name.includes(excludeName))) {
      return false;
    }
    return true;
  };

  return (
    <>
      <CustomToast
        position="top-center"
        theme="light"
        pauseOnHover
        hideProgressBar={true}
        autoClose={1000}
        closeButton={false}
      />
      {isShowComponent(pathname) && <Header type="mypage" />}
      <Outlet />
      {isShowComponent(pathname) && <Footer />}
    </>
  );
};

const AppLogin = () => {
  return (
    <Provider store={store}>
      <AppLoginContent />
    </Provider>
  );
};

export default AppLogin;
